import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            I am <span className="light-brown">Valencia, Spain </span> based
            <br />
            <br />
            I've been <span className="light-brown">loving technology </span> in general since I was 12 years old,
            and <span className="light-brown">software development </span> in particular since we first
            met a few years later.
            <br />
            <br />
            My other passions and interests:
          </p>
          <ul>
            <li className="about-activity">
              🧗  &nbsp; Climbing
            </li>
            <li className="about-activity">
              🏄‍♂  &nbsp; Surfing️
            </li>
            <li className="about-activity">
              🎮  &nbsp; Gaming
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
